import styled from 'styled-components'

import { helpers } from 'styles'

export const Subtitle = styled.span`
	font: ${helpers.fonts.body.medium};
	color: ${helpers.color.text};
	opacity: 0.8;
`
